import React from 'react'
import "../Styles/happy-feets.css"

export default function Happyfeets() {
    return (
        <div className="happy-feet">
        <div className="img">
          <img src="Images/Slider3.JPG" alt="" />
        </div>
        <div className="text">
          <h2>Happy Feet Equals a Happy Mood!</h2>
          <p>
            DOKMEN socks are designed to to bring joy and pleasure into everyday
            life, make you feel happy. Whenever, wherever, whatever you do. The
            chosen materials give a pleasant feeling to your feet and bring a
            smile to everyone's face! Our DOKMEN Socks are the ultimate gift for
            friends, colleagues and family!
          </p>
        </div>
      </div>
    )
}
